import { c } from '../../utils/tailwind-merge';
import { UserAssetsCollection } from '../UserAssetsList/UserAssetsCollection';
import type { PublisherListsProps } from './types';

export const PublisherLists = ({
  lists,
  microcopy,
  className = '',
}: PublisherListsProps) => {
  return (
    <div className={c('-mx-2 flex flex-wrap', className)}>
      {lists.map((list) => (
        <UserAssetsCollection key={list.link} microcopy={microcopy} {...list} />
      ))}
    </div>
  );
};
